import { createContext } from "react";
import type { ModalStack, RenderFunction } from ".";

type ModalContext = {
    render: RenderFunction<any>;
    stack: ModalStack;
};

export const ModalContext = createContext<ModalContext | null>(null);
